// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__pGFVg","productName":"Table_productName__15Wxd"};